import PropTypes from 'prop-types';
import classNames from 'classnames';

import Text from '@hiredigital/ui/Text/Text';
import Img from '@components/Img';
import { Section, SectionContainer } from '@components/Section';
import InteractiveButton from '@components/InteractiveButton/InteractiveButton';
import Styles from './GenericCta.module.scss';

const GenericCta = ({ title, description, linkTo, buttonLabel, className, analyticsData }) => {
  return (
    <SectionContainer style={{ minHeight: '300px' }} anchor='midcta'>
      <Section className={classNames(className)}>
        <div className={Styles.wrapper}>
          <div className={Styles.imageContainer}>
            <Img
              src={`/img/need-talent@2x.webp`}
              alt='image'
              className={Styles.imageItem}
              wrapperClassName={Styles.image}
            />
          </div>
          <div className={Styles.textContainer}>
            <Text
              element='p'
              size={Text.Size.H2}
              color={Text.Color.BLACK}
              className={Styles.ctaHeadline}>
              {title}
            </Text>
            <Text element='p' color={Text.Color.BLACK} className={Styles.ctaDescription}>
              {description}
            </Text>
            <InteractiveButton
              type={InteractiveButton.Type.WHITE}
              className={Styles.sectionCta}
              title=''
              href={{
                pathname: linkTo,
                query: { ...analyticsData },
              }}>
              {buttonLabel}
            </InteractiveButton>
          </div>
        </div>
      </Section>
    </SectionContainer>
  );
};

GenericCta.propTypes = {
  title: PropTypes.string,
  buttonLabel: PropTypes.string,
  description: PropTypes.string,
  linkTo: PropTypes.string,
  className: PropTypes.string,
};

export default GenericCta;
